function getFormData(obj: any) {
  const formData = new FormData();
  const objectCleaned = obj;

  for (const key in objectCleaned) {
    if (
      objectCleaned[key] instanceof File ||
      objectCleaned[key] instanceof Blob
    ) {
      formData.append(key, objectCleaned[key]);
    } else if (objectCleaned.hasOwnProperty(key)) {
      let value = objectCleaned[key];
      if (value === false || value === 0) {
        value = 0;
      }

      if (Array.isArray(value)) {
        isArrayOfObjects(formData, value, key);
      } else if (typeof value === "object" && value !== null) {
        isObject(formData, value, key);
      } else {
        formData.append(key, value);
      }
    }
  }

  return formData;
}

export default getFormData;

const isArrayOfObjects = (formData: any, value: any, key: any) => {
  for (let index = 0; index < value.length; index++) {
    const item = value[index];

    if (typeof item === "object" && item !== null) {
      for (const subKey in item) {
        if (item.hasOwnProperty(subKey)) {
          if (item[subKey] instanceof File) {
            formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
          } else if (
            typeof item[subKey] === "object" &&
            item[subKey] !== null
          ) {
            isObject(
              formData,
              item[subKey],
              `${key}[${index}][${subKey}]`
            );
          } else {
            formData.append(`${key}[${index}][${subKey}]`, item[subKey]);
          }
        }
      }
    } else {
      formData.append(`${key}[${index}]`, item);
    }
  }
};

const isObject = (formData: any, value: any, key: any) => {
  for (const subKey in value) {
    if (value.hasOwnProperty(subKey)) {
      if (value[subKey] instanceof File) {
        formData.append(`${key}[${subKey}]`, value[subKey]);
      } else if (
        typeof value[subKey] === "object" &&
        value[subKey] !== null
      ) {
        isObject(formData, value[subKey], `${key}[${subKey}]`);
      } else {
        formData.append(`${key}[${subKey}]`, value[subKey]);
      }
    }
  }
};
